import DOMPurify from 'dompurify';

export const getSaveHtml = (html: string) => DOMPurify.sanitize(html);
